import React from 'react';
import { ShieldCheckIcon, ExternalLinkIcon } from 'lucide-react';
export function NRARulesLink() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-2661">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-2662">
        <div className="flex items-center gap-4 p-6 rounded-xl mb-12 shadow-sm" style={{
        backgroundColor: '#1e3d2f'
      }} data-id="element-2663">
          <ShieldCheckIcon size={24} className="flex-shrink-0" style={{
          color: '#c8a84b'
        }} data-id="element-2664" />
          <div className="flex-1" data-id="element-2665">
            <p className="text-sm mb-1" style={{
            color: '#a0c8b0',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-2666">
              Official NRA Rules:
            </p>
            <a href="https://lecompetitions.nra.org/media/4725/rulebook.pdf" target="_blank" rel="noopener noreferrer" className="text-base font-semibold transition-colors hover:underline" style={{
            color: '#c8a84b',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-2667">
              View the NRA Police Pistol Combat Rulebook
            </a>
          </div>
          <ExternalLinkIcon size={20} className="flex-shrink-0" style={{
          color: '#a0c8b0'
        }} data-id="element-2668" />
        </div>
      </div>
    </div>;
}